import {PersonRequestBody, PersonResponseBodyV2} from '@dms/api/customer';

export const toPersonRequestBody = (
  person: PersonResponseBodyV2,
  permanentAddressId: string | null
): PersonRequestBody => ({
  personData: {
    firstName: person.firstName,
    lastName: person.lastName,
    middleName: person.middleName,
    titleBefore: person.titleBefore,
    titleAfter: person.titleAfter,
    genderKey: person.genderKey,
    roles: person.roles,
    citizenshipCode: person.citizenshipCode,
    birthdate: person.birthdate,
    personalIdentifier: person.personalIdentifier,
  },
  phoneNumbers: [],
  emails: [],
  identityCards: [],
  permanentAddressId,
});
